import type { ReactNode } from 'react';
import { SECTIONS, type SectionKey } from '../sections';

export interface SectionCardProps {
  readonly section?: SectionKey;
  readonly title?: ReactNode;
  readonly action?: ReactNode;
  readonly padded?: boolean;
  readonly className?: string;
  readonly children: ReactNode;
}

export function SectionCard({
  section,
  title,
  action,
  padded = true,
  className,
  children,
}: SectionCardProps) {
  const sec = section ? SECTIONS[section] : null;

  return (
    <div
      className={[
        'native-screen-enter app-shell-surface overflow-hidden rounded-[28px] border border-border shadow-card backdrop-blur-xl',
        className ?? '',
      ].join(' ')}
      style={sec ? { borderColor: sec.edge } : undefined}
    >
      {title && (
        <div className="flex items-start justify-between gap-3 px-4 pt-4">
          <div className="min-w-0">
            {sec && (
              <div className="mb-1.5 flex items-center gap-2 text-caption font-semibold uppercase tracking-[0.12em] text-ink-muted">
                <span
                  className="h-1.5 w-1.5 rounded-full"
                  style={{ background: sec.color }}
                  aria-hidden
                />
                {sec.label}
              </div>
            )}
            <h3 className="truncate text-h2 font-semibold tracking-[-0.02em] text-ink">
              {title}
            </h3>
          </div>
          {action && <div className="shrink-0 pt-0.5">{action}</div>}
        </div>
      )}
      <div className={padded ? (title ? 'px-4 pb-4 pt-3.5' : 'p-4') : ''}>{children}</div>
    </div>
  );
}
